import { render, staticRenderFns } from "./CIMWorkloadDashboardView.vue?vue&type=template&id=5c40204d&scoped=true&"
import script from "./CIMWorkloadDashboardView.vue?vue&type=script&lang=ts&"
export * from "./CIMWorkloadDashboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40204d",
  null
  
)

export default component.exports